// Dev server environment configuration
export const environment = {
  production: false,
  envName: 'dev' as 'local' | 'dev' | 'prod',
  isBeta: true, // Closed-beta gating: redirect /register → /contact, disable plan changes
  apiUrl: 'https://api.dev.smartlink.tn', // Backend API
  docsUrl: 'https://docs.dev.smartlink.tn', // Docusaurus site
  apiVersion: 'v1',
  appName: 'SmartLink',
  auth: {
    tokenKey: 'smartlink_access_token',
    refreshTokenKey: 'smartlink_refresh_token',
    userKey: 'smartlink_user',
  },
  features: {
    enableAnalytics: false,
    enableQRCode: true,
    enableCustomDomains: false,
  },
};
// Frontend will be hosted at: https://dev.smartlink.tn
